import { render, staticRenderFns } from "./PsCollapse.vue?vue&type=template&id=46f26576&"
import script from "./PsCollapse.vue?vue&type=script&lang=js&"
export * from "./PsCollapse.vue?vue&type=script&lang=js&"
import style0 from "./PsCollapse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports